import * as React from "react";

function SvgBin(props) {
  return (
    <svg width={17} height={20} {...props}>
      <defs>
        <path
          d="M542.278 138.493l.782 12.56c.023.358.379.684.747.684h9.467c.37 0 .694-.304.709-.663l.51-12.58h1.027l-.511 12.619c-.037.896-.815 1.624-1.735 1.624h-9.467c-.92 0-1.716-.728-1.772-1.624l-.785-12.62h1.028zm6.616 0v11.634h-1.027v-11.634h1.027zm3.197 0l-.326 11.634h-1.027l.326-11.634h1.027zm-6.317 0l.337 11.634h-1.027l-.337-11.634h1.027zm4.614-5.493c.918 0 1.665.727 1.665 1.62v1.3h4.148c.284 0 .514.225.514.5 0 .276-.23.5-.514.5h-15.687a.508.508 0 01-.514-.5c0-.275.23-.5.514-.5h4.148v-1.3c0-.893.747-1.62 1.665-1.62zm0 1h-4.061a.637.637 0 00-.637.62v1.3h5.336v-1.3a.638.638 0 00-.638-.62z"
          id="Bin_svg__a"
        />
      </defs>
      <use
        fill="currentColor"
        xlinkHref="#Bin_svg__a"
        transform="translate(-540 -133)"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgBin;
